import { Home, Map, Wallet, Heart } from "lucide-react";
import { cn } from "@/lib/utils";

export type TabId = "home" | "feed" | "budget" | "favorites";

interface BottomNavProps {
  active: TabId;
  onTabChange: (tab: TabId) => void;
  lang: "fr" | "en";
}

const tabs: { id: TabId; icon: typeof Home; labelFr: string; labelEn: string }[] = [
  { id: "home", icon: Home, labelFr: "Accueil", labelEn: "Home" },
  { id: "feed", icon: Map, labelFr: "Carte", labelEn: "Map" },
  { id: "budget", icon: Wallet, labelFr: "Budget", labelEn: "Budget" },
  { id: "favorites", icon: Heart, labelFr: "Favoris", labelEn: "Favorites" },
];

const BottomNav = ({ active, onTabChange, lang }: BottomNavProps) => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-t border-border/20 rounded-t-2xl shadow-[0_-4px_24px_rgba(0,0,0,0.08)]">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
        {tabs.map(({ id, icon: Icon, labelFr, labelEn }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-xl transition-all duration-200",
                isActive
                  ? "text-primary scale-105"
                  : "text-muted-foreground hover:text-foreground active:scale-95"
              )}
            >
              <Icon
                className={cn(
                  "w-5 h-5 transition-all duration-200",
                  isActive && "drop-shadow-[0_0_6px_hsl(var(--primary)/0.4)]"
                )}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className={cn(
                "text-[10px] leading-tight transition-all duration-200",
                isActive ? "font-bold" : "font-medium"
              )}>
                {lang === "fr" ? labelFr : labelEn}
              </span>
            </button>
          );
        })}
      </div>
      {/* Safe area for iOS */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
};

export default BottomNav;
